import React, { FC } from 'react';
import styled from 'styled-components';
import { media } from 'src/styles/designs';
import { Swiper, SwiperSlide } from 'swiper/react';
import { ProductsSectionItem } from 'src/modules/products/components/ProductsSectionItems/ProductsSectionItem';
import { BaseProductDTO } from 'src/models/pim';

const StyleSwiper = styled(Swiper)`
  .swiper-slide {
    width: auto;
  }
`;

const Container = styled.div`
  margin-left: 25px;
  position: relative;
  margin-right: calc(-1 * var(--constraint-container-right-inner-margin));
  margin-left: calc(-1 * var(--constraint-container-left-inner-margin));

  ${media.w.greaterThanOrEqual.desktop} {
    margin-left: 160px;
  }
`;

interface ProductSectionItemsSwiperProps {
  products: BaseProductDTO[];
}

export const ProductSectionItemsSwiper: FC<ProductSectionItemsSwiperProps> = ({
  products,
}) => {
  return (
    <Container>
      <StyleSwiper
        slidesPerView={'auto'}
        centeredSlides={true}
        spaceBetween={30}
      >
        {products.map((product) => (
          <SwiperSlide key={product.code}>
            <ProductsSectionItem product={product} />
          </SwiperSlide>
        ))}
      </StyleSwiper>
    </Container>
  );
};
